// extracted by mini-css-extract-plugin
export var bodyRow = "_g6-d";
export var cardColumns = "_g6-e";
export var ellipsesOverflow = "_g6-2";
export var flatBottomCorners = "_g6-3";
export var flatTopCorners = "_g6-4";
export var headerActionsDropdown = "_g6-f";
export var headerBottomRow = "_g6-c";
export var headerTopRow = "_g6-b";
export var orderDetailsWrapper = "_g6-0";
export var orderInfoContainer = "_g6-1";
export var productDetails = "_g6-9";
export var productImage = "_g6-5";
export var responsiveTable = "_g6-8";
export var shipmentContainer = "_g6-a";
export var tableBottomLeft = "_g6-6";
export var tableBottomRight = "_g6-7";
export var trackingLink = "_g6-g";